import { Flex, Icon } from '@inflearn/ds-react';
import { useLang } from '@inflearn/i18n-tools';
import { MyCategoryModalWrapper } from '@inflearn/modals';
import { faStar } from '@inflearn/pro-solid-svg-icons';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'next-i18next';

import { eventNames } from '../../../../../utils/GTM/eventNames';
import { useTrackMixpanelEvent } from '../../../../../utils/GTM/useTrackMixpanelEvent';
import { SettingSection } from '../common/SettingSection';

/**
 * 마카테는 window.env를 따라가기 때문에 로컬 실행시 endpoint가 localhost가 됨.
 * 마카테가 잘 동작하고 싶은지 확인하고 싶다면 _document.tsx에서 window.env 변경해서 확인.
 */
export const MyCategorySection = () => {
  const { t } = useTranslation();
  const { lang } = useLang();
  const [opened, { open, close }] = useDisclosure();
  const { trackMixpanelEvent } = useTrackMixpanelEvent();

  const handleClick = () => {
    trackMixpanelEvent(eventNames.CLICK_MY_CATEGORY_ACCOUNT);
    open();
  };

  return (
    <>
      <SettingSection.Button
        title={t('MY 카테고리')}
        description={t('나만의 강의 카테고리를 구성해보세요!')}
        onClick={handleClick}
        right={
          <Flex p={10} bg="infgreen.0" css={{ borderRadius: 8 }} align="center" justify="center">
            <Icon icon={faStar} color="infgreen.6" size={18} />
          </Flex>
        }
      />
      <MyCategoryModalWrapper
        lang={lang}
        opened={opened}
        onClose={close}
        myCategorySpot="account"
        closeOnClickOutside
      />
    </>
  );
};
